import React, { useState } from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '../Sheet';
import { Badge } from '../Badge';
import { Input } from '../Input';
import { Shield, Eye, Download, UserCog, Search, FileText, Activity, Filter, X } from 'lucide-react';
const logs = [{
  time: '15:42:18',
  date: '23 Mei',
  actor: 'VVIP-01',
  role: 'Presiden RI',
  action: 'VIEW',
  target: '/dashboard',
  result: 'OK',
  icon: Eye
}, {
  time: '15:41:02',
  date: '23 Mei',
  actor: 'A-12',
  role: 'Analis',
  action: 'EXPORT',
  target: 'Actor Network Report (PDF)',
  result: 'OK',
  icon: Download
}, {
  time: '15:38:55',
  date: '23 Mei',
  actor: 'CC-03',
  role: 'Cmd Center',
  action: 'ROLE_CHANGE',
  target: 'Tim Komunikasi → Analis',
  result: 'OK',
  icon: UserCog
}, {
  time: '15:33:11',
  date: '23 Mei',
  actor: 'SYS',
  role: 'System',
  action: 'TAKEDOWN_REQ',
  target: 'CMP-2026-001 → TikTok',
  result: 'SUBMITTED',
  icon: Shield
}, {
  time: '15:29:00',
  date: '23 Mei',
  actor: 'A-08',
  role: 'Analis',
  action: 'SEARCH',
  target: '"deepfake audio"',
  result: '147 hits',
  icon: Search
}, {
  time: '15:22:30',
  date: '23 Mei',
  actor: 'KSP-04',
  role: 'Kepala Staf',
  action: 'CREATE',
  target: 'TSK-011 (Tasking)',
  result: 'OK',
  icon: FileText
}, {
  time: '15:14:09',
  date: '23 Mei',
  actor: 'VVIP-01',
  role: 'Presiden RI',
  action: 'APPROVE',
  target: 'Daily Brief 23-05-2026',
  result: 'OK',
  icon: Eye
}, {
  time: '14:58:12',
  date: '23 Mei',
  actor: 'A-12',
  role: 'Analis',
  action: 'EVIDENCE_HASH',
  target: 'EVD-2026-0142',
  result: 'a3f9...c812',
  icon: Shield
}, {
  time: '14:42:00',
  date: '23 Mei',
  actor: 'SYS',
  role: 'System',
  action: 'AUTO_ALERT',
  target: 'Threat KRITIS — deepfake',
  result: 'ESCALATED',
  icon: Shield
}, {
  time: '14:30:00',
  date: '23 Mei',
  actor: 'AUD-01',
  role: 'Auditor',
  action: 'VIEW_AUDIT',
  target: 'Audit Log',
  result: 'OK',
  icon: Eye
}];
const actionStyle: Record<string, {
  text: string;
  bg: string;
  border: string;
}> = {
  VIEW: {
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  },
  EXPORT: {
    text: 'text-purple-700',
    bg: 'bg-purple-50',
    border: 'border-purple-200'
  },
  ROLE_CHANGE: {
    text: 'text-amber-700',
    bg: 'bg-amber-50',
    border: 'border-amber-200'
  },
  TAKEDOWN_REQ: {
    text: 'text-red-700',
    bg: 'bg-red-50',
    border: 'border-red-200'
  },
  SEARCH: {
    text: 'text-slate-700',
    bg: 'bg-slate-100',
    border: 'border-slate-200'
  },
  CREATE: {
    text: 'text-emerald-700',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200'
  },
  APPROVE: {
    text: 'text-emerald-700',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200'
  },
  EVIDENCE_HASH: {
    text: 'text-amber-700',
    bg: 'bg-amber-50',
    border: 'border-amber-200'
  },
  AUTO_ALERT: {
    text: 'text-red-700',
    bg: 'bg-red-50',
    border: 'border-red-200'
  },
  VIEW_AUDIT: {
    text: 'text-blue-700',
    bg: 'bg-blue-50',
    border: 'border-blue-200'
  }
};
const resultTone = (r: string) => {
  if (r === 'OK') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (r === 'ESCALATED' || r === 'SUBMITTED') return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-slate-100 text-slate-700 border-slate-200';
};
export function AuditLogSheet({
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const [q, setQ] = useState('');
  const filtered = logs.filter(l => !q || [l.actor, l.role, l.action, l.target].join(' ').toLowerCase().includes(q.toLowerCase()));
  return <Sheet open={open} onOpenChange={onOpenChange} data-id="element-289">
      <SheetContent className="w-full sm:max-w-xl bg-background border-border/60 p-0 flex flex-col" data-id="element-290">
        <SheetHeader className="px-6 py-5 border-b border-border/60" data-id="element-291">
          <div className="flex items-center gap-2 mb-1" data-id="element-292">
            <div className="size-7 rounded-md bg-primary/10 border border-primary/20 flex items-center justify-center" data-id="element-293">
              <Activity className="size-3.5 text-primary" data-id="element-294" />
            </div>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground" data-id="element-295">
              System Trail
            </span>
            <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200 font-mono text-[9px] ml-auto" data-id="element-296">
              IMMUTABLE
            </Badge>
          </div>
          <SheetTitle className="text-lg" data-id="element-297">Audit Log</SheetTitle>
          <SheetDescription data-id="element-298">
            Jejak audit sistem dalam 1 jam terakhir. Semua tindakan tercatat,
            tertanda waktu, dan tidak dapat diubah.
          </SheetDescription>
          <div className="mt-3 relative" data-id="element-299">
            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 size-3.5 text-muted-foreground" data-id="element-300" />
            <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Cari aktor, aksi, atau target..." className="pl-8 bg-muted/30 border-border/60" data-id="element-301" />
          </div>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4" data-id="element-302">
          <div className="flex items-center justify-between mb-3" data-id="element-303">
            <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-304">
              {filtered.length} dari {logs.length} entri
            </p>
            <button className="font-mono text-[10px] text-primary hover:underline flex items-center gap-1" data-id="element-305">
              <Filter className="size-3" data-id="element-306" /> Filter lanjutan
            </button>
          </div>

          <div className="space-y-2.5" data-id="element-307">
            {filtered.map((l, i) => {
            const s = actionStyle[l.action] ?? actionStyle.VIEW;
            return <div key={i} className="group rounded-lg border border-border/60 bg-card hover:border-primary/30 hover:shadow-sm transition p-3.5" data-id="element-308">
                  {/* Row 1: time + actor + result */}
                  <div className="flex items-center gap-3 mb-2.5" data-id="element-309">
                    <div className={`size-8 rounded-md ${s.bg} border ${s.border} flex items-center justify-center shrink-0`} data-id="element-310">
                      <l.icon className={`size-3.5 ${s.text}`} data-id="element-311" />
                    </div>
                    <div className="min-w-0 flex-1" data-id="element-312">
                      <p className="font-mono text-[11px] text-foreground font-semibold leading-tight" data-id="element-313">
                        {l.actor}
                        <span className="font-normal text-muted-foreground ml-1.5" data-id="element-314">
                          · {l.role}
                        </span>
                      </p>
                      <p className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground mt-0.5" data-id="element-315">
                        {l.date} · {l.time} WIB
                      </p>
                    </div>
                    <Badge variant="outline" className={`font-mono text-[9px] px-2 py-0.5 ${resultTone(l.result)}`} data-id="element-316">
                      {l.result}
                    </Badge>
                  </div>

                  {/* Row 2: action + target */}
                  <div className="flex items-center gap-2 pl-11 flex-wrap" data-id="element-317">
                    <span className={`font-mono text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${s.bg} ${s.text} border ${s.border}`} data-id="element-318">
                      {l.action}
                    </span>
                    <span className="text-muted-foreground text-[10px]" data-id="element-319">→</span>
                    <code className="font-mono text-[11px] text-foreground/90 bg-muted/40 px-1.5 py-0.5 rounded border border-border/60 truncate" data-id="element-320">
                      {l.target}
                    </code>
                  </div>
                </div>;
          })}
            {filtered.length === 0 && <div className="text-center py-12" data-id="element-321">
                <Search className="size-8 text-muted-foreground/40 mx-auto mb-2" data-id="element-322" />
                <p className="text-sm text-muted-foreground" data-id="element-323">
                  Tidak ada entri yang cocok dengan "{q}"
                </p>
                <button onClick={() => setQ('')} className="mt-3 font-mono text-[10px] text-primary hover:underline inline-flex items-center gap-1" data-id="element-324">
                  <X className="size-3" data-id="element-325" /> Hapus pencarian
                </button>
              </div>}
          </div>
        </div>

        <div className="border-t border-border/60 px-6 py-3 bg-card/50" data-id="element-326">
          <div className="flex items-center justify-between font-mono text-[10px] text-muted-foreground" data-id="element-327">
            <span className="flex items-center gap-1.5" data-id="element-328">
              <span className="size-1.5 rounded-full bg-emerald-500 animate-pulse" data-id="element-329" />
              Streaming live · BSSN compliance
            </span>
            <span data-id="element-330">UU PDP 27/2022</span>
          </div>
        </div>
      </SheetContent>
    </Sheet>;
}